import { useEffect } from 'react';

export const ChildSafetyPage = () => {
  useEffect(() => {
    document.title = 'Política de Segurança Infantil – Joyn';
  }, []);

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-card border border-border rounded-xl px-8 py-10 shadow-sm">
          <div className="flex flex-col items-center mb-8 text-center">
            <img src="/logo_eventfy.png" alt="Joyn" className="w-48 h-auto object-contain mb-6" />
            <h1 className="text-xl font-semibold text-foreground">Política de Segurança Infantil</h1>
            <p className="text-xs text-muted-foreground mt-1">Última atualização: Junho de 2026</p>
          </div>

          <div className="space-y-5 text-sm text-muted-foreground leading-relaxed">
            <p>
              O Joyn não tolera qualquer forma de exploração, abuso ou conteúdo sexual envolvendo
              menores de idade.
            </p>

            <p>
              Usuários podem denunciar conteúdos, eventos, perfis ou comportamentos inadequados por
              meio dos canais de suporte disponibilizados pela plataforma.
            </p>

            <p>
              Qualquer conteúdo que promova, facilite ou contenha material de abuso sexual infantil
              (CSAM) será removido imediatamente e poderá ser reportado às autoridades competentes,
              conforme exigido pela legislação aplicável.
            </p>

            <p>
              O Joyn coopera com autoridades responsáveis pela proteção infantil e adota medidas para
              investigar denúncias relacionadas à segurança de menores.
            </p>

            <div className="pt-2 border-t border-border">
              <p>Contato para questões relacionadas à segurança infantil:</p>
              <a
                href="mailto:oficialjoyn@gmail.com"
                className="text-primary hover:underline mt-1 inline-block"
              >
                oficialjoyn@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
